import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">FCPS Reunions · Connecting Alumni</p>
        <h1>Welcome to FCPS Reunions</h1>
        <p className="lede">
          Your go-to platform for organizing and promoting reunions for Fairfax County Public Schools graduates. 
          Reconnect with old friends and relive cherished memories.
        </p>
        <div className="cta-row">
          <a href="/about" target="_self">
            Learn More
          </a>
          <a href="/register" target="_self" className="secondary">
            Start Planning Your Reunion
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Effortless Planning</h2>
          <p>
            Our platform simplifies the reunion planning process, allowing you to focus on what matters most: reconnecting with your classmates.
          </p>
        </article>
        <article>
          <h2>Promote Your Event</h2>
          <p>
            Utilize our tools to effectively promote your reunion, ensuring that no one misses out on the fun.
          </p>
        </article>
        <article>
          <h2>Stay Connected</h2>
          <p>
            Join our community to stay updated on upcoming reunions and connect with fellow alumni throughout the year.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;